import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  tag: 'Bono 1',
  img: 'https://cdn.magicpatterns.com/uploads/mJukA1JHm6rAuzieBfLfsk/PLANTILLAS_PARA_PRACTICAR.png',
  title: 'Plantillas para practicar',
  desc: 'Ejercicios de líneas, curvas, contornos, rellenos y combinaciones de color para ganar confianza antes de pintar tu primera pieza final.'
}, {
  tag: 'Bono 2',
  img: 'https://cdn.magicpatterns.com/uploads/qaa8UtDGWFgFdQCdbpc315/2B300_plantillas.png',
  title: '+300 plantillas listas para imprimir',
  desc: 'Diseños preparados para usar en frascos, cuadros, portavelas, espejos, atrapasoles y souvenirs, sin tener que dibujar desde cero.'
}, {
  tag: 'Bono 3',
  img: 'https://cdn.magicpatterns.com/uploads/2f24YcoA8Aw8z57e1ZhAiG/2B100_IDEAS_PARA_VENDER.png',
  title: '+100 ideas para vender',
  desc: 'Inspiración para transformar tus piezas en regalos, souvenirs, sets, decoración para el hogar y productos personalizados.'
}, {
  tag: 'Bono 4',
  img: 'https://cdn.magicpatterns.com/uploads/5EDrFSQeGGfqh7XAT7p8Kj/GUIA_DE_EMPRENDIMIENTO.png',
  title: 'Guía de emprendimiento',
  desc: 'Cómo calcular precios, armar combos, sacar buenas fotos, vender por Instagram y WhatsApp y organizar tus pedidos.'
}];
export function Bonuses() {
  return <section className="bg-deco-cream py-14 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-29" data-mp="3n6g5iqr4qpus">
      <div className="max-w-4xl mx-auto" data-id="element-30" data-mp="2zesl8rodid1h">
        <p className="text-center text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-31" data-mp="2zhogg88u6nm8">
          Incluido sin costo extra
        </p>
        <h2 className="text-center font-serif text-2xl sm:text-4xl text-deco-forest font-semibold mb-4" data-id="element-32" data-mp="38h1sn8ochqan">
          Y solo por hoy, los{' '}
          <span className="italic text-deco-brick" data-id="element-33" data-mp="33jifkc3dvjka">bonos de regalo</span>
        </h2>
        <p className="text-center text-sm text-deco-forest/60 max-w-xl mx-auto mb-12 leading-relaxed" data-id="element-34" data-mp="no6s7qe81kqz">
          Recursos extra para practicar, crear más diseños y empezar a vender
          tus piezas desde el primer día.
        </p>

        <div className="flex flex-col gap-5 sm:gap-6" data-id="element-35" data-mp="3hhr8tob8x21o">
          {bonuses.map((bonus, i) => <motion.article key={bonus.tag} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-deco-beige rounded-[1.75rem] p-6 sm:p-8 border border-deco-aqua/30 flex flex-col sm:flex-row gap-6 sm:gap-9 items-center ${i % 2 === 1 ? 'sm:flex-row-reverse' : ''}`} data-id="element-36" data-mp="3ljun0kpaukqn" data-mpi={i}>
              <img src={bonus.img} alt={bonus.title} className="w-40 sm:w-48 shrink-0 object-contain drop-shadow-xl" data-id="element-37" data-mp="2a4z9j22e2pbo" />
              <div className="text-center sm:text-left" data-id="element-38" data-mp="27jzy1r6zs5bx">
                <span className="inline-block text-[10px] font-semibold uppercase tracking-[0.2em] text-deco-brick bg-deco-brick/10 rounded-full px-3 py-1 mb-3" data-id="element-39" data-mp="27jhro1qm8aqa">
                  {bonus.tag}
                </span>
                <h3 className="font-serif text-lg sm:text-2xl text-deco-forest font-semibold leading-snug mb-3" data-id="element-40" data-mp="1xnwuqi0em0ne">
                  {bonus.title}
                </h3>
                <p className="text-[13px] sm:text-sm text-deco-forest/65 leading-relaxed" data-id="element-41" data-mp="1olxc5l9qqoic">
                  {bonus.desc}
                </p>
              </div>
            </motion.article>)}
        </div>

        <p className="text-center font-serif italic text-base sm:text-lg text-deco-brick mt-10 max-w-xl mx-auto leading-relaxed" data-id="element-42" data-mp="1evvkykm3cpz7">
          Las plantillas son el recurso que te permite pasar de “quiero
          aprender” a “ya puedo empezar a crear”.
        </p>
      </div>
    </section>;
}